// src/utils/getAPI-config.ts

let BASE_URL = 'http://apiWentWrong:5000'; // Default base URL

export const loadConfig = async () => {
  try {
    const response = await fetch('/config.json');
    const config = await response.json();
    BASE_URL = config.API_URL || BASE_URL; // Fallback to default if not found
  } catch (error) {
    console.error('Failed to load configuration: API', error);
  }
};

export const getBaseUrl = () => {
  // Check for environment variable first
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // If config is loaded, use it
  if (BASE_URL) {
    return BASE_URL;
  }

  console.warn('Using default BASE_URL API:', BASE_URL);
  return BASE_URL;
};
